module.exports = __webpack_public_path__ + "static/ifsupport-1b0087d65738d8997eb1779d9d29492d.png";